import React from 'react';
import PropTypes from 'prop-types';
import { CardCarousel } from '@thd-olt-component-react/card-carousel'
import {
  extend,
  params,
  shape,
  string,
  useDataModel
} from '@thd-nucleus/data-sources';

// TODO: Add additional entry ids by lowercase region (ie: 'northern')
// Business will need to create these through contentful
const RegionalEntryIds = {
  // northern: '',
  // eastern: '',
  // southern: '',
  // western: '',
  default: '48xKwe3wVD0awQpDjrMoBU'
};

const RecommendationsPod = ({ storeNumber }) => {
  // const { loading, data, error } = useDataModel('emtGardenContent', { variables: { storeId: storeNumber } });

  // if (!data || loading || error || !data.emtGardenContent) {
  //   return null;
  // }

  // const storeRegion = data.emtGardenContent?.articleGuides?.storeRegion?.toLowerCase();
  const entryId = RegionalEntryIds.default;

  return (
    <CardCarousel entryId={entryId} />
  );
};

RecommendationsPod.propTypes = {
  storeNumber: PropTypes.string.isRequired
};

RecommendationsPod.displayName = 'RecommendationsPod';

RecommendationsPod.dataModel = extend({},
  CardCarousel
);

export default RecommendationsPod;